import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from '@reach/router';
import { Formik, Field, FieldProps, FieldArray } from 'formik';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';

import { RootState } from 'store/store';
import Address from 'store/entity/Address';
import {
  IProvider,
  IProviderItemView,
  IProviders,
  SurveyOwnerProperties,
} from 'store/providers/providerTypes';
import {
  item_createNewSurvey,
  item_createNewSurveyFn,
  requireProviderTags,
  requireProviderTagsFn,
  updateProvider,
  updateProviderFn,
  updateSurveyOwnerProperties,
} from 'store/providers/providerSlice';

import messages from '../Messages';
import Icon from 'components/Icon';
import Input from 'components/Input';
import Button from 'components/Button';
import Select from 'components/Select';
import Textarea from 'components/Textarea/Textarea';
// import ActionLink from 'components/ActionLink';
// import GoogleMaps from 'components/GoogleMaps';
import { IOption } from 'components/Select/Select';
import { display } from 'components/ErrorView/ErrorDialog';
import LogoLoading from 'components/LogoLoading';
import { InformationForm } from './styles';
import notify from 'components/Notify';
import {
  getAllCategories,
  getAllCategoriesFn,
  ICategories,
  ICategory,
} from 'store/categories/categoriesSlice';
import Collapsible from '../../../../components/Collapsible/Collapsible';
import {
  DayRow,
  DayRowGetHours,
  DayRowHours,
  DayRowHoursSection,
  DayRowHoursText,
  DayRowTitle,
  DaySelectSection,
} from '../../../../components/Collapsible/styles';
import { appDispatch } from 'store/store';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { ICompany, ICompanyState } from 'store/companies/companiesTypes';
import {
  getMyCompanies,
  getMyCompaniesFn,
} from 'store/companies/companiesSlice';
import {
  IQuestionTags,
  SurveyAnalyseTemplateType,
} from 'store/survey/surveyTypes';
import cloneDeep from 'lodash/cloneDeep';
import { getTags } from '../../../../components/FileManager/ItemsViewer/Survey/SurveyEditor/GeneralQuestion/GeneralQuestionEditor';
import { arraysEqual } from '../../../../utils/happyFunctions';

// const JSGoogleMaps: any = GoogleMaps;

interface IStateToProps {
  thisUser: IThisUserState;
  companies: ICompanyState;
  thisProvider: IProviders['map'][0];
  categories: ICategories;
  tags?: IQuestionTags;
}

interface IDispatchToProps {
  requireProviderTags: (
    providerId: number
  ) => () => ReturnType<typeof requireProviderTagsFn>;
  updateProvider: (provider: IProvider) => ReturnType<typeof updateProviderFn>;
  updateSurveyOwnerProperties: (
    properties: SurveyOwnerProperties,
    token: string,
    providerId: number
  ) => ReturnType<typeof updateProviderFn>;
  getMyCompanies: () => ReturnType<typeof getMyCompaniesFn>;
  getAllCategories: () => ReturnType<typeof getAllCategoriesFn>;
  createProviderSurvey: (
    item: IProviderItemView
  ) => ReturnType<typeof item_createNewSurveyFn>;
}

interface IOwnProps {
  providerId?: number;
  hasGeneralAccess: boolean;
}

type IComponentProps = IOwnProps &
  IStateToProps &
  IDispatchToProps &
  RouteComponentProps;
export type inputHour = { fromMinutes: number; toMinutes: number };
export type WorkingHours = { days: { value: number; range: inputHour[] }[] };
type dayType = {
  name: string;
  value: number;
  edit: boolean;
  hours: inputHour[];
  to: [];
  from: [];
};
interface IInformationState {
  creatingAnalyses: boolean;
  saving: boolean;
  loadingCompanies: boolean;
  loadingCategories: boolean;
  days: dayType[];
  hours: {
    hour: { value: number; label: string }[];
    minute: { value: number; label: string }[];
  };
}

export interface IInformationValues {
  name: string;
  address: string;
  location: { lat: number; lng: number; mapMarker: boolean };
  postalCode: string;
  description: string;
  phoneNumber: string;
  workingContext: string;
  username: string;
  managingCompanyId?: IOption;
  categories?: number[];
  limitAccessToCompany?: boolean;
  useVirtualSpaces?: boolean;
  allowSeeThroughItems?: boolean;
  days?: any;
  tags?: number[];
}

class Information extends React.PureComponent<
  IComponentProps,
  IInformationState
> {
  constructor(props: IComponentProps) {
    super(props);
    const hours: {
      hour: { value: number; label: string }[];
      minute: { value: number; label: string }[];
    } = { hour: [], minute: [] };
    let m = 0;
    while (m < 60) {
      if (m % 5 === 0)
        hours.minute.push({
          value: m,
          label: (m < 10 ? '0' : '') + m,
        });
      if (m < 24)
        hours.hour.push({
          value: m,
          label: (m < 10 ? '0' : '') + m,
        });
      m += 1;
    }
    this.state = {
      creatingAnalyses: false,
      saving: false,
      loadingCompanies: true,
      loadingCategories: false,
      days: [
        { name: 'شنبه', value: 0, edit: false, hours: [], to: [], from: [] },
        { name: 'یک‌شنبه', value: 1, edit: false, hours: [], to: [], from: [] },
        { name: 'دوشنبه', value: 2, edit: false, hours: [], to: [], from: [] },
        { name: 'سه‌شنبه', value: 3, edit: false, hours: [], to: [], from: [] },
        {
          name: 'چهارشنبه',
          value: 4,
          edit: false,
          hours: [],
          to: [],
          from: [],
        },
        {
          name: 'پنج‌شنبه',
          value: 5,
          edit: false,
          hours: [],
          to: [],
          from: [],
        },
        { name: 'جمعه', value: 6, edit: false, hours: [], to: [], from: [] },
        {
          name: 'روزهای تعطیل',
          value: -1,
          edit: false,
          hours: [],
          to: [],
          from: [],
        },
      ],
      hours: hours,
    };
  }

  componentDidMount() {
    this.props.getMyCompanies().then(() => {
      this.setState({ loadingCompanies: false });
    });
    if (!this.props.tags)
      this.props.requireProviderTags(this.props.providerId!);
    if (Object.values(this.props.categories).length === 0) {
      this.setState({ loadingCategories: true });
      this.props.getAllCategories().then(
        () => {
          this.setState({ loadingCategories: false });
        },
        () => {
          this.setState({ loadingCategories: false });
        }
      );
    }
  }

  handleSaveInformation = (
    values: IInformationValues,
    { setFieldValue }: { setFieldValue: any }
  ) => {
    this.setState({ saving: true });
    const { thisUser, thisProvider } = this.props;
    const provider = cloneDeep(thisProvider.data!);
    provider.name = values.name;
    const workingHours: any = { days: [] };
    this.state.days.map((item) => {
      workingHours.days.push({
        day: item.value,
        ranges: values.days[item.value]?.hours ?? [],
      });
    });
    provider.address = new Address(
      values.address,
      values.location.lat,
      values.location.lng,
      values.postalCode,
      values.phoneNumber,
      workingHours
    );
    provider.user = Number(thisUser.userId);
    provider.description = values.description;
    provider.username = values.username;
    provider.categories = values.categories || [];
    if (!provider.publicProperties) provider.publicProperties = {};
    provider.publicProperties.workingContext = values.workingContext;
    provider.managingCompanyId = values.managingCompanyId
      ? Number(values.managingCompanyId.value)
      : null;

    provider.limitAccessToCompany = !!values.limitAccessToCompany;
    provider.allowSeeThroughItems = !!values.allowSeeThroughItems;
    provider.useVirtualSpaces = !!values.useVirtualSpaces;
    this.props.updateProvider(provider).then(
      (response: any) => {
        this.setState({ saving: false });
        const workingDays: any = response.data?.address?.workingHours?.days;
        if (workingDays) {
          setFieldValue('days', this.makeDailyHours(workingDays));
        }
        notify(messages.successfullySaved);
      },
      (err: any) => {
        this.setState({ saving: false });
        display(err);
      }
    );

    const newSurveyOwnwerTags = values.tags;
    const oldSurveyOwnerTags = provider.surveyOwnerProperties.addedTagIds;
    if (!arraysEqual(newSurveyOwnwerTags, oldSurveyOwnerTags)) {
      const newProps = { addedTagIds: newSurveyOwnwerTags || [] };
      this.props.updateSurveyOwnerProperties(
        newProps,
        provider.surveyOwnerToken!,
        provider.id
      );
    }
  };

  editDay = (
    values: IInformationValues,
    setFieldValue: any,
    index: number,
    cancel: boolean
  ) => {
    const tempValue = { ...values.days };
    if (!tempValue[index])
      tempValue[index] = {
        edit: false,
        hours: [],
        textHour: [],
        fromMinute: [],
        fromHour: [],
        toMinute: [],
        toHour: [],
        update: -1,
      };
    if (tempValue[index].edit && !cancel) {
      const hour = {
        fromMinutes:
          tempValue[index].fromHour[0].value * 60 +
          tempValue[index].fromMinute[0].value,
        toMinutes:
          tempValue[index].toHour[0].value * 60 +
          tempValue[index].toMinute[0].value,
      };
      const text = {
        fromMinutes:
          tempValue[index].fromHour[0].label +
          ':' +
          tempValue[index].fromMinute[0].label,
        toMinutes:
          tempValue[index].toHour[0].label +
          ':' +
          tempValue[index].toMinute[0].label,
      };
      if (tempValue[index].update > -1) {
        tempValue[index].hours[tempValue[index].update] = hour;
        tempValue[index].textHour[tempValue[index].update] = text;
      } else {
        tempValue[index].hours.push(hour);
        tempValue[index].textHour.push(text);
      }
    }
    tempValue[index].hours = tempValue[index].hours.sort((a: any, b: any) =>
      a.fromMinutes > b.fromMinutes ? 1 : b.fromMinutes > a.fromMinutes ? -1 : 0
    );
    tempValue[index].textHour = tempValue[index].textHour.sort(
      (a: any, b: any) =>
        a.fromMinutes > b.fromMinutes
          ? 1
          : b.fromMinutes > a.fromMinutes
            ? -1
            : 0
    );
    tempValue[index].edit = !tempValue[index].edit;
    tempValue[index].update = -1;
    tempValue[index].fromMinute = [];
    tempValue[index].fromHour = [];
    tempValue[index].toMinute = [];
    tempValue[index].toHour = [];
    setFieldValue('days', tempValue);
  };
  editHour = (
    values: IInformationValues,
    setFieldValue: any,
    edit: boolean,
    index: number,
    hIndex: number
  ) => {
    const tempValue = {
      ...values.days,
    };
    if (edit) {
      tempValue[index].fromHour = [
        {
          label: values.days[index].textHour[hIndex].fromMinutes.split(':')[0],
          value: Math.floor(values.days[index].hours[hIndex].fromMinutes / 60),
        },
      ];
      tempValue[index].fromMinute = [
        {
          label: values.days[index].textHour[hIndex].fromMinutes.split(':')[1],
          value: values.days[index].hours[hIndex].fromMinutes % 60,
        },
      ];
      tempValue[index].toHour = [
        {
          label: values.days[index].textHour[hIndex].toMinutes.split(':')[0],
          value: Math.floor(values.days[index].hours[hIndex].toMinutes / 60),
        },
      ];
      tempValue[index].toMinute = [
        {
          label: values.days[index].textHour[hIndex].toMinutes.split(':')[1],
          value: values.days[index].hours[hIndex].toMinutes % 60,
        },
      ];
      tempValue[index].edit = !tempValue[index].edit;
      tempValue[index].update = hIndex;
    } else {
      tempValue[index].hours.splice(hIndex, 1);
      tempValue[index].textHour.splice(hIndex, 1);
      tempValue[index].update = -1;
    }
    setFieldValue('days', tempValue);
  };
  addHourValidation = (values: IInformationValues, day: dayType): boolean => {
    return (
      values.days[day.value]['fromMinute'].length === 0 ||
      values.days[day.value]['fromHour'].length === 0 ||
      values.days[day.value]['toMinute'].length === 0 ||
      values.days[day.value]['toHour'].length === 0 ||
      values.days[day.value]['fromHour'][0]?.value >
        values.days[day.value]['toHour'][0]?.value ||
      (values.days[day.value]['fromHour'][0]?.value ===
        values.days[day.value]['toHour'][0]?.value &&
        values.days[day.value]['fromMinute'][0]?.value >=
          values.days[day.value]['toMinute'][0]?.value)
    );
  };
  makeDailyHours = (values: any) => {
    const tempDays = {};
    values?.map((day: any) => {
      tempDays[day.day] = {
        edit: false,
        hours: [],
        textHour: [],
        fromMinute: [],
        fromHour: [],
        toMinute: [],
        toHour: [],
        update: -1,
      };
      day.ranges?.map((hour: any) => {
        tempDays[day.day].hours.push({
          fromMinutes: hour.fromMinutes,
          toMinutes: hour.toMinutes,
        });
        tempDays[day.day].textHour.push({
          fromMinutes:
            this.state.hours.hour[Math.floor(hour.fromMinutes / 60)]?.label +
            ':' +
            this.state.hours.minute[(hour.fromMinutes % 60) / 5]?.label,
          toMinutes:
            this.state.hours.hour[Math.floor(hour.toMinutes / 60)]?.label +
            ':' +
            this.state.hours.minute[(hour.toMinutes % 60) / 5]?.label,
        });
      });
    });
    return tempDays;
  };

  changeValue = (index: number, type: string, value: any) => {
    const days = [...this.state.days];
    days[index][type] = value;
    this.setState({ days: days });
  };
  render() {
    const times: any[] = [
      { name: 'fromMinute', placeholder: 'دقیقه', value: 'minute' },
      { name: 'fromHour', placeholder: 'ساعت', value: 'hour' },
      { name: 'toMinute', placeholder: 'دقیقه', value: 'minute' },
      { name: 'toHour', placeholder: 'ساعت', value: 'hour' },
    ];
    const {
      thisProvider,
      companies,
      categories,
      hasGeneralAccess = false,
    } = this.props;
    let tempDays = {};
    const values = thisProvider.data?.address?.workingContext?.days;
    tempDays = this.makeDailyHours(values);
    const initialValues: IInformationValues = {
      days: tempDays,
      name: thisProvider.data!.name || '',
      workingContext: thisProvider.data?.publicProperties?.workingContext || '',
      description: thisProvider.data?.description || '',
      address: thisProvider.data?.address.text || '',
      location: {
        lat: thisProvider.data?.address.latitude || null,
        lng: thisProvider.data?.address.longitude || null,
        mapMarker: true,
      },
      postalCode: thisProvider.data?.address.postalCode || '',
      phoneNumber: thisProvider.data?.address.phoneNumber || '',
      username: thisProvider.data?.username || '',
      managingCompanyId: thisProvider.data?.managingCompanyId
        ? {
            value: thisProvider.data.managingCompanyId,
            label: companies.data[thisProvider.data.managingCompanyId]?.name,
          }
        : undefined,
      limitAccessToCompany: thisProvider.data?.limitAccessToCompany,
      categories: thisProvider.data?.categories,
      useVirtualSpaces: thisProvider.data?.useVirtualSpaces,
      allowSeeThroughItems: thisProvider.data?.allowSeeThroughItems,
      tags: thisProvider.data?.surveyOwnerProperties?.addedTagIds,
    };
    const userCompanies: IOption[] = Object.values(companies.data).reduce(
      (list: IOption[], company: ICompany) => {
        const item: IOption = {
          label: company.name,
          value: company.id,
        };
        list.push(item);
        return list;
      },
      []
    );
    const categoriesOption = Object.values(categories).reduce(
      (current, item: ICategory) => {
        current.push({
          value: item.id,
          label: item.name,
          parent: item.parent,
        });
        return current;
      },
      [] as IOption[]
    );
    const tagsOption = getTags((this.props.tags as any) || {}, true);
    const analyseTemplate = thisProvider!.data!.documents.find(
      (e) => e.type === 'survey' && e.templateType === SurveyAnalyseTemplateType
    );

    const createAnalyseTemplate = () => {
      this.setState({ creatingAnalyses: true });
      this.props
        .createProviderSurvey({
          name: 'Analyse Template',
          providerId: this.props.providerId!,
          status: 'exists',
          type: 'survey',
          editable: true,
          templateType: 'SurveyAnalyse',
        } as any)
        .then((e) => {
          this.setState({ creatingAnalyses: false });
          window.open(
            // @ts-expect-error it's ok!
            `/content/${this.props.providerId}/direct/${e.data.id}`,
            '_blank'
          );
        });
    };
    return (
      <Fragment>
        <Helmet>
          <title>{messages.generalInformation}</title>
          <meta name="description" content={messages.generalInformation} />
        </Helmet>
        {this.state.loadingCompanies ? (
          <LogoLoading />
        ) : (
          <Formik
            onSubmit={this.handleSaveInformation}
            initialValues={initialValues}
            validateOnBlur={false}
            validateOnChange={false}
            render={({
              values,
              // values: { location, managingCompanyId },
              setFieldValue,
            }) => (
              <InformationForm className="row">
                <div
                  className={!hasGeneralAccess ? 'col m6 s12' : 'col m12 s12'}
                >
                  <Field
                    name="name"
                    render={({ field }: FieldProps) => {
                      return (
                        <Input
                          {...field}
                          type="text"
                          id="name"
                          icon="user"
                          label={messages.name}
                          placeholder={messages.name}
                        />
                      );
                    }}
                  />
                </div>
                {!hasGeneralAccess && (
                  <>
                    <div className="col m6 s12">
                      <Field
                        name="username"
                        render={({ field }: FieldProps) => (
                          <Input
                            {...field}
                            type="text"
                            id="username"
                            icon="at-sign"
                            label={messages.username}
                            placeholder={messages.username}
                          />
                        )}
                      />
                    </div>
                    <div className="col m6 s12">
                      <Field
                        name="workingContext"
                        render={({ field }: FieldProps) => (
                          <Input
                            {...field}
                            type="text"
                            id="workingContext"
                            icon="briefcase"
                            label={messages.subject}
                            placeholder={messages.subject}
                          />
                        )}
                      />
                    </div>
                    <div className="col m6 s12">
                      <Field
                        name="postalCode"
                        render={({ field }: FieldProps) => (
                          <Input
                            {...field}
                            type="text"
                            id="postalCode"
                            icon="crosshair"
                            label={messages.postalCode}
                            placeholder={messages.postalCode}
                          />
                        )}
                      />
                    </div>
                    <div className="col m6 s12">
                      <Field
                        name="phoneNumber"
                        render={({ field }: FieldProps) => (
                          <Input
                            {...field}
                            type="text"
                            id="phoneNumber"
                            icon="phone"
                            label={messages.phoneNumber}
                            placeholder={messages.phoneNumber}
                          />
                        )}
                      />
                    </div>
                    <div className="col m6 s12">
                      <Field
                        name="managingCompanyId"
                        render={() => (
                          <Select
                            options={userCompanies}
                            values={
                              values.managingCompanyId && [
                                values.managingCompanyId,
                              ]
                            }
                            onChangeValues={(selectedCompany) => {
                              const companyId = selectedCompany[0];
                              setFieldValue('managingCompanyId', companyId);
                              // to sync limitAccessToCompany value with managingCompanyId
                              let isLimit: boolean = false;
                              if (
                                companyId &&
                                initialValues.managingCompanyId &&
                                companyId.value ===
                                  initialValues.managingCompanyId.value
                              ) {
                                isLimit = !!initialValues.limitAccessToCompany;
                              }
                              setFieldValue('limitAccessToCompany', isLimit);
                            }}
                            label={messages.relatedCompany}
                            placeholder={messages.selectACompany}
                          />
                        )}
                      />
                      {values.managingCompanyId && (
                        <Field
                          name="limitAccessToCompany"
                          render={({ field }: FieldProps) => (
                            <Input
                              {...field}
                              id="limitAccessToCompany"
                              type="checkbox"
                              checked={field.value}
                              label={messages.limitAccessToCompanyMembers(
                                values?.managingCompanyId?.label ?? ''
                              )}
                            />
                          )}
                        />
                      )}
                    </div>
                    <div className="col m6 s12">
                      <Field
                        name="allowSeeThroughItems"
                        render={({ field }: FieldProps) => (
                          <Input
                            {...field}
                            id="allowSeeThroughItems"
                            type="checkbox"
                            checked={field.value}
                            label={messages.allowSeeThroughItems}
                          />
                        )}
                      />
                    </div>
                    <div className="col m6 s12">
                      <Field
                        name="useVirtualSpaces"
                        render={({ field }: FieldProps) => (
                          <Input
                            {...field}
                            id="useVirtualSpaces"
                            type="checkbox"
                            checked={field.value}
                            label={messages.useVirtualSpaces}
                          />
                        )}
                      />
                    </div>
                    <div className="col m12 s12" style={{ marginTop: '1rem' }}>
                      <Icon type="file-text" />
                      <Field
                        name="description"
                        render={({ field }: FieldProps) => (
                          <Textarea
                            {...field}
                            id="description"
                            label={messages.description}
                            placeholder={messages.description}
                          />
                        )}
                      />
                    </div>
                    <div className="col m12 s12" style={{ marginTop: '1rem' }}>
                      <Collapsible header={messages.workingHours}>
                        <FieldArray name="days">
                          {() =>
                            this.state.days.map((day, index) => (
                              <DayRow key={index}>
                                <DayRowTitle>{day.name}</DayRowTitle>
                                <DayRowHoursSection>
                                  {values.days[day.value]?.textHour?.map(
                                    (hour: inputHour, hIndex: number) =>
                                      hIndex !==
                                      values.days[day.value].update ? (
                                        <DayRowHours key={hIndex}>
                                          <DayRowHoursText>
                                            {hour.fromMinutes} تا{' '}
                                            {hour.toMinutes}
                                          </DayRowHoursText>
                                          <Icon
                                            onClick={() =>
                                              this.editHour(
                                                values,
                                                setFieldValue,
                                                true,
                                                day.value,
                                                hIndex
                                              )
                                            }
                                            type={'edit'}
                                            style={{
                                              fontSize: '18px',
                                              marginRight: '10px',
                                            }}
                                            className="pointer"
                                          />
                                          <Icon
                                            onClick={() =>
                                              this.editHour(
                                                values,
                                                setFieldValue,
                                                false,
                                                day.value,
                                                hIndex
                                              )
                                            }
                                            type={'x-square'}
                                            style={{
                                              fontSize: '18px',
                                              marginRight: '10px',
                                            }}
                                            className="pointer"
                                          />
                                        </DayRowHours>
                                      ) : null
                                  )}
                                  <DayRowGetHours>
                                    {values.days[day.value]?.edit ? (
                                      <DaySelectSection>
                                        {times.map((selectType, selIndex) => (
                                          <Field
                                            key={selIndex}
                                            render={() => {
                                              return (
                                                <>
                                                  {selIndex === 2 && (
                                                    <div
                                                      style={{ margin: '5px' }}
                                                    >
                                                      {' ' + messages.to + ' '}
                                                    </div>
                                                  )}
                                                  <Select
                                                    allowRemove={false}
                                                    onChangeValues={(
                                                      selectValues
                                                    ) => {
                                                      const tempValue = {
                                                        ...values.days,
                                                      };
                                                      tempValue[day.value][
                                                        selectType.name
                                                      ] = selectValues;
                                                      setFieldValue(
                                                        'days',
                                                        tempValue
                                                      );
                                                    }}
                                                    options={
                                                      this.state.hours[
                                                        selectType.value
                                                      ]
                                                    }
                                                    containerStyle={{
                                                      marginRight: '10px',
                                                      width: '60px',
                                                    }}
                                                    placeholder={
                                                      selectType.placeholder
                                                    }
                                                    values={
                                                      values.days[day.value][
                                                        selectType.name
                                                      ] ?? []
                                                    }
                                                  />
                                                </>
                                              );
                                            }}
                                          />
                                        ))}
                                        <Icon
                                          type={'check-square'}
                                          onClick={() =>
                                            this.editDay(
                                              values,
                                              setFieldValue,
                                              day.value,
                                              false
                                            )
                                          }
                                          disabled={this.addHourValidation(
                                            values,
                                            day
                                          )}
                                          style={{
                                            fontSize: '18px',
                                            marginRight: '10px',
                                          }}
                                          className="pointer"
                                        />
                                        <Icon
                                          type={'x-square'}
                                          onClick={() =>
                                            this.editDay(
                                              values,
                                              setFieldValue,
                                              day.value,
                                              true
                                            )
                                          }
                                          style={{
                                            fontSize: '18px',
                                            marginRight: '10px',
                                          }}
                                          className="pointer"
                                        />
                                      </DaySelectSection>
                                    ) : (
                                      <Icon
                                        onClick={() =>
                                          this.editDay(
                                            values,
                                            setFieldValue,
                                            day.value,
                                            false
                                          )
                                        }
                                        type={'plus-square'}
                                        style={{
                                          fontSize: '18px',
                                          marginRight: '10px',
                                        }}
                                        className="pointer"
                                      />
                                    )}
                                  </DayRowGetHours>
                                </DayRowHoursSection>
                              </DayRow>
                            ))
                          }
                        </FieldArray>
                      </Collapsible>
                    </div>
                    <div className="col m12 s12">
                      <Icon type="map-pin" />
                      <Field
                        name="address"
                        render={({ field }: FieldProps) => (
                          <Textarea
                            {...field}
                            id="address"
                            label={messages.address}
                            placeholder={messages.address}
                          />
                        )}
                      />
                    </div>
                    {categories && (
                      <div className="col m12 s12">
                        <Field
                          name="categories"
                          render={({ field }: FieldProps) => (
                            <Select
                              onChangeValues={(values) => {
                                setFieldValue(
                                  'categories',
                                  values.map((it) => it.value as number)
                                );
                              }}
                              multiChoice={true}
                              allowRemove={true}
                              label={messages.categories}
                              placeholder={messages.addCategory}
                              options={categoriesOption}
                              values={(field.value as number[]).reduce(
                                (current: IOption[], it: number) => {
                                  if (categories[it])
                                    current.push({
                                      value: categories[it].id!,
                                      label: categories[it].name!,
                                    });
                                  return current;
                                },
                                []
                              )}
                            />
                          )}
                        />
                      </div>
                    )}
                    {this.props.tags && (
                      <div className="col m12 s12">
                        <Field
                          name="tags"
                          render={({ field }: FieldProps) => (
                            <Select
                              onChangeValues={(values) => {
                                setFieldValue(
                                  'tags',
                                  values.map((it) => it.value as number)
                                );
                              }}
                              multiChoice={true}
                              allowRemove={true}
                              label={messages.tags}
                              options={tagsOption}
                              values={(field.value as number[]).reduce(
                                (current: IOption[], it: number) => {
                                  current.push({
                                    value: it!,
                                    label: this.props.tags?.[it]?.text || '',
                                  });
                                  return current;
                                },
                                []
                              )}
                            />
                          )}
                        />
                      </div>
                    )}
                    {/*<MapWrapper className="col m12 s12">*/}
                    {/*  <Icon type="map" />*/}
                    {/*  <SelectLocationHint>*/}
                    {/*    {messages.selectTheLocationOnTheMap}*/}
                    {/*  </SelectLocationHint>*/}
                    {/*  {!!values.location.lat && (*/}
                    {/*    <span style={{ float: 'left' }}>*/}
                    {/*      <ActionLink*/}
                    {/*        color="red"*/}
                    {/*        onClick={() => {*/}
                    {/*          setFieldValue('location', {*/}
                    {/*            lat: null,*/}
                    {/*            lng: null,*/}
                    {/*            mapMarker: false,*/}
                    {/*          });*/}
                    {/*        }}*/}
                    {/*      >*/}
                    {/*        {messages.removeLocation}*/}
                    {/*      </ActionLink>*/}
                    {/*    </span>*/}
                    {/*  )}*/}
                    {/*  <Field*/}
                    {/*    name="location"*/}
                    {/*    render={() => (*/}
                    {/*      <JSGoogleMaps*/}
                    {/*        lat={values.location.lat}*/}
                    {/*        lng={values.location.lng}*/}
                    {/*        width="100%"*/}
                    {/*        height="300px"*/}
                    {/*        marker={values.location.mapMarker}*/}
                    {/*        handleChangeLatLng={(lat: number, lng: number) => {*/}
                    {/*          setFieldValue('location', {*/}
                    {/*            lat,*/}
                    {/*            lng,*/}
                    {/*            mapMarker: true,*/}
                    {/*          });*/}
                    {/*        }}*/}
                    {/*      />*/}
                    {/*    )}*/}
                    {/*  />*/}
                    {/*</MapWrapper>*/}
                  </>
                )}
                <div className="col m12 s12">
                  <Button
                    type="submit"
                    color="black"
                    style={{ width: '100%' }}
                    loading={this.state.saving}
                  >
                    {messages.save}
                  </Button>
                </div>
              </InformationForm>
            )}
          />
        )}

        {!hasGeneralAccess && (
          <div>
            {analyseTemplate ? (
              <Button
                color="black"
                onClick={() => {
                  window.open(
                    `/content/${this.props.providerId}/direct/${analyseTemplate.id}`,
                    '_blank'
                  );
                }}
              >
                {messages.editAnalyseTemplate}
              </Button>
            ) : (
              <Button
                color="black"
                loading={this.state.creatingAnalyses}
                onClick={createAnalyseTemplate}
              >
                {messages.createAnalyseTemplate}
              </Button>
            )}
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const thisUser = state.thisUser;
  const providerId = Number(props.providerId);
  const thisProvider = state.providers.map[providerId];
  const companies = state.companies;
  const categories = state.categories;
  const tags = state.providers.tags[props.providerId!]?.data;
  return {
    tags,
    thisUser,
    companies,
    thisProvider,
    categories,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => {
  return {
    updateProvider: (provider: IProvider) =>
      appDispatch(updateProvider({ provider })),
    updateSurveyOwnerProperties: (
      surveyOwnerProperties: SurveyOwnerProperties,
      token: string,
      providerId: number
    ) =>
      appDispatch(
        updateSurveyOwnerProperties({
          surveyOwnerProperties,
          token,
          providerId,
        })
      ),
    createProviderSurvey: (item: IProviderItemView) => {
      return appDispatch(item_createNewSurvey({ item }));
    },
    getMyCompanies: () => appDispatch(getMyCompanies({})),
    getAllCategories: () => appDispatch(getAllCategories({})),
    requireProviderTags: (providerId: number) =>
      appDispatch(requireProviderTags({ providerId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Information);
